<div *ngIf="loading" style="position: fixed; top: 50%; left: 48%">
  <app-loading-page></app-loading-page>
</div>
<div *ngIf="!loading" class="mb-4">
  <div class="task-card cursor-pointer"
    (click)="handleEmitEvent(card?.signalingType, waitingForEdition ? 'edit' : 'open', card.id || null, card?.taskType)">
    <div class="d-flex mx-0 align-items-center justify-content-between" [ngClass]="{ 'text-muted': disabled }">
      <div class="d-flex mx-0 align-items-center" style="width: 21ch">
        <i class="fa-regular fa-lg" [ngClass]="ngIconClass"></i>
        <div class="mx-2 name">{{ card.name || (card?.taskType | enumText: 'TaskType') }}</div>
      </div>
      <div class="btn-group pr-2" dropdown container="body" placement="bottom right" (click)="$event.stopPropagation()">
        <button class="btn btn-icon dropdown-toggle ellipsis-cell" dropdownToggle type="button">
          <i class="fas fa-ellipsis-vertical" style="font-size: 20px"></i> <span class="caret"></span>
        </button>
        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right p-3" role="menu"
          aria-labelledby="button-basic">
          <li role="menuitem">
            <a [ngClass]="{ 'disabled-li': card.status == taskStatusEnum.Canceled }"
              class="gray-dark dropdown-item p-3 d-flex justify-content-start cursor-pointer"
              (click)="handleEmitEvent(card?.signalingType, 'edit', card.id || null, card.taskType)">Editar</a>
          </li>
          <li role="menuitem">
            <a class="dropdown-item p-3 d-flex justify-content-start cursor-pointer text-danger"
              (click)="openModal(removeWarning)">Remover</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row mx-0 align-items-center d-flex my-2">
      <div class="category-data type">{{ card.signalingType | enumText: 'SignalingType' }}</div>
      <i class="fa-solid fa-flag fa-xl mx-2 text-success" *ngIf="!waitingForEdition" [ngClass]="{
          'text-danger': card.priority == priorityEnum.High,
          'text-warning': card.priority == priorityEnum.Medium
        }"></i>
      <i class="fa-solid fa-circle fa-lg px-2" [class]="card.status"></i>
      {{ card?.status ? (card?.status | enumText: 'TaskStatus') : 'Tarefa em construção' }}
    </div>
    <ng-container *ngIf="!waitingForEdition; else elseBlock">
      <div class="row mx-0 align-items-center d-flex my-2 justify-content-between">
        <div class="row d-flex align-items-center mx-0" style="height: 30px">
          <img *ngIf="card.team" class="image-rounded" [src]="
              card.team?.leaderMember?.user?.imageURL
                ? card.team?.leaderMember?.user?.imageURL
                : 'assets/icons/camera.svg'
            " alt="" height="32px" width="32px" />
          <i *ngIf="card.team && card.vehicles?.length" class="fa-solid fa-link mx-2 text-muted"></i>
          <ng-container *ngIf="card.vehicles?.length">
            <img class="image-rounded"
              [src]="card.vehicles[0]?.vehicleImage ? card.vehicles[0].vehicleImage.url : 'assets/icons/camera.svg'"
              alt="" />
            <p class="m-0 mx-2 plate">
              {{ card.vehicles[0]?.licensePlate }}<span *ngIf="card.vehicles.length > 1" class="text-muted"> +{{
                card.vehicles.length - 1 }}</span>
            </p>
          </ng-container>
          <p *ngIf="!card.team && !card.vehicles?.length" class="m-0 mx-2 plate text-danger"
            style="font-weight: 500; pointer-events: none">
            Sem Equipe e Sem Veículo
          </p>
        </div>
        <div class="row d-flex align-items-center mx-0 date">
          <i class="fa-solid fa-xl text-muted fa-calendar-clock mx-1"></i>
          {{ card?.executionDate | date: 'dd/MM/yyyy' }}
        </div>
      </div>
      <div [hidden]="card.taskType == taskTypeEnum.Cataloging">
        <div class="row mx-0 d-flex justify-content-between align-items-center text-muted my-2">
          <div class="col-auto px-0" style="font-size: 12px">Atividade</div>
          <div class="col-auto px-0" style="font-size: 10px">
            Progresso {{ taskActivities?.completedActivities + '/' + taskActivities?.activities }}
          </div>
        </div>
        <div class="d-flex">
          <div class="progress-task-bar" *ngFor="let activity of taskActivitiesProgress; let last = last" [ngStyle]="{
              'margin-right': !last ? '8px' : '0px',
              background: activity ? 'var(--green-base)' : 'var(--snow-base)'
            }"></div>
        </div>
      </div>
    </ng-container>
    <ng-template #elseBlock>
      <div class="row mx-0 align-items-center d-flex my-2 justify-content-center">
        <div class="col text-center">
          <h3 class="text-primary">{{ signsLength }}</h3>
          <p class="text-muted mb-2">{{ signsLength > 1 ? 'Sinalizações' : 'Sinalização' }} do Catálogo</p>
          <small>Aguardando edição...</small>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<!-- Modal de Excluir Contrato -->
<ng-template #removeWarning>
  <div class="modal-header">
    <h3 class="modal-title">Remover tarefa</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
      <i aria-hidden="true" class="fas fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body mx-3">
    <p class="m-0" style="font-weight: 500">Tem certeza que deseja remover a tarefa da lista?</p>
  </div>

  <div class="modal-footer">
    <div class="row justify-content-end">
      <div class="col-auto">
        <button type="button" class="btn btn-outline-primary" (click)="modalRef.hide()">cancelar</button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-primary"
          (click)="handleEmitEvent(card?.signalingType, 'remove', card.id || null, taskType); modalRef.hide()">
          remover
        </button>
      </div>
    </div>
  </div>
</ng-template>
